module.exports = __webpack_public_path__ + "img/5.9e7e0971.png";